__turbopack_context__.v({
  "backdrop": "SearchBackdrop-module__5ng1mG__backdrop",
  "blok-big-title": "SearchBackdrop-module__5ng1mG__blok-big-title",
  "blok-subtitle": "SearchBackdrop-module__5ng1mG__blok-subtitle",
  "blok-title": "SearchBackdrop-module__5ng1mG__blok-title",
  "fadeIn": "SearchBackdrop-module__5ng1mG__fadeIn",
});
